module.exports = __webpack_public_path__ + "media/images/front/favicon-9ecce35f4cc8e20dd4d51183f1269273.ico";